window.addEventListener('load', function () {

    var defaultOptionOrderSelect = document.querySelector('.defaultOptionsOrder');
    if (defaultOptionOrderSelect != null) {
        defaultOptionOrderSelect.firstChild.setAttribute("selected", "selected");
        defaultOptionOrderSelect.addEventListener('change', function (event) {
            event.preventDefault();

            const url = "/site.axd/BusinessCard/DefaultOptionsOrderOnChange";
            var req = new XMLHttpRequest();
            var data = defaultOptionOrderSelect.options[defaultOptionOrderSelect.selectedIndex];
            var variantId = defaultOptionOrderSelect.getAttribute("variantId");
            var orderId = defaultOptionOrderSelect.getAttribute("orderId");
            var orderRowId = defaultOptionOrderSelect.getAttribute("orderRowId");
            req.open("POST", url + "?" + "fieldId=" + data.value + "&variantId=" + variantId + "&orderId=" + orderId + "&orderRowId=" + orderRowId, false);
            req.onload = function () {
                if (req.status >= 200 && req.status < 400) {
                    var resp = req.responseText;
                    if (document.querySelector('#orderEditForm') != null) {
                        document.querySelector('#orderEditForm').innerHTML = resp;
                    }
                }
            };
            req.send();
        });
    }
    var importFileButton = document.querySelector('.import-file-button');
    var importFileButtonLabel = document.querySelector('.import-file-button-label');
    var saveImportButton = document.querySelector('.save-import-button');
    var fileImportButton = document.querySelector('.file-button-import');
    if (importFileButton != null) {

        importFileButton.addEventListener('change', function (event) {

            var importFiles = importFileButton.files;
            var fileName = '';
            if (importFiles && importFiles.length > 1) {
                fileName = (importFiles.getAttribute('data-multiple-caption') || '').replace('{count}',
                    importFiles.files.length);
                importFileButtonLabel.textContent = fileName;
                saveImportButton.style.display = 'block';

            } else if (event.target.value) {
                fileName = event.target.value.split('\\').pop();
                importFileButtonLabel.textContent = fileName;
                saveImportButton.style.display = 'block';

            }
        });
    }
    function defaultOptionsInit() {
        var defaultOptionSelect = document.querySelector('.defaultOptions');
        if (defaultOptionSelect != null && defaultOptionSelect.firstChild != null) {
            defaultOptionSelect.firstChild.setAttribute("selected", "selected");
            defaultOptionSelect.addEventListener('change', function (event) {
                event.preventDefault();
                const url = "/site.axd/BusinessCard/DefaultOptionsOnChange";
                var req = new XMLHttpRequest();
                var data = defaultOptionSelect.options[defaultOptionSelect.selectedIndex];
                var variantId = defaultOptionSelect.getAttribute("variantId");
                req.open("POST", url + "?" + "fieldId=" + data.value + "&variantId=" + variantId, false);
                req.onload = function () {
                    if (req.status >= 200 && req.status < 400) {
                        var resp = req.responseText;
                        if (document.querySelector('#pdfFieldsForm') != null) {
                            document.querySelector('#pdfFieldsForm').innerHTML = resp;
                            createPreviewClickInit();
                        }
                    }
                };
                req.send();
            });
        }
    }

    function createPreviewClickInit() {
        var createPreviewButtonClass = '.psm-create-preview-button';
        var defaultOptionsSelectClass = 'select.defaultOptions';

        var createPreviewButtonEl = document.querySelector(createPreviewButtonClass);
        var defaultOptionsSelectEl = document.querySelector(defaultOptionsSelectClass);
        if (createPreviewButtonEl && defaultOptionsSelectEl) {
            createPreviewButtonEl.addEventListener('click', reloadSelect);

            function reloadSelect(event) {

                // Check if save-checkbox is checked
                if (!document.getElementById('SaveDefaultOptionChecked').checked) {
                    return;
                }
                
                setTimeout(function () {
                    const url = location.href;
                    elementLoad(url, '#DefaultOptions', '#DefaultOptions', true);
                }, 1500);
            }
        }
    }

    function elementLoad(url, sourceContainer, targetContainer, replace) {
        var xhr = new XMLHttpRequest();
        xhr.onerror = function () {
            throw "Request failed. HTTP code " + xhr.status;
        };
        xhr.onload = function () {

            if (!xhr.status || (xhr.status >= 400)) {
                throw "Request failed. HTTP code " + xhr.status;
            }
            let temp = document.createElement("DIV");
            temp.innerHTML = xhr.responseText;
            const el = temp.querySelector(sourceContainer);
            const targetEl = document.querySelector(targetContainer);

            if (el && targetEl) {
                if (replace) {
                    targetEl.innerHTML = el.innerHTML;
                } else {
                    targetEl.appendChild(el);
                }
            }
        };
        xhr.open("GET", url, true);
        xhr.send();
    }

    createPreviewClickInit();
    defaultOptionsInit();
});